export default __webpack_public_path__ + "static/media/check-icon.f5d1de85.svg";